/** Vite-exposed env (prefix VITE_). */
export const API_URL =
  import.meta.env.VITE_API_URL || "http://localhost:5000/api";

export const SOCKET_URL = (import.meta.env.VITE_SOCKET_URL || "").trim();

/** LiveKit Cloud WSS URL — optional fallback if the session API omits livekitUrl. */
export const LIVEKIT_URL = (import.meta.env.VITE_LIVEKIT_URL || "").trim();
